import React from 'react';
import cx from './cx';

function Stepper({ steps = [], className, ariaLabel }) {
  return (
    <div className={cx('rg-stepper', className)} role="list" aria-label={ariaLabel}>
      {steps.map((step, index) => {
        const stateClass = step.state ? `rg-stepper__item--${step.state}` : '';
        return (
          <div
            key={step.id || `${step.label}-${index}`}
            className={cx('rg-stepper__item', stateClass)}
            role="listitem"
            aria-current={step.state === 'active' ? 'step' : undefined}
          >
            <div className="rg-stepper__icon">{step.icon || <span>{index + 1}</span>}</div>
            <div className="rg-stepper__meta">
              {step.number === false ? null : (
                <div className="rg-stepper__number">{step.number || `Paso ${index + 1}`}</div>
              )}
              <div className="rg-stepper__name">{step.label}</div>
              {step.description ? <div className="rg-stepper__description">{step.description}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Stepper;
